import Vue from "vue";
import Vuetify from "vuetify/lib";

const colors = require("vuetify/es5/util/colors").default;

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi" // default - only for display purposes
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#0b63ff",
        accent: "#54a3b3",
        secondary: "#ffec00",
        info: colors.teal.lighten1,
        warning: colors.amber.base,
        error: colors.deepOrange.accent4,
        success: colors.green.accent3
      }
      // dark: {
      //   primary: "#9a3870",
      //   accent: "#54a3b3",
      //   secondary: "#ffec00",
      //   info: colors.teal.lighten1,
      //   warning: colors.amber.base,
      //   error: colors.deepOrange.accent4,
      //   success: colors.green.accent3
      // }
    }
  }
});
